/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateCouponBatchShopifyAllTarget { 
    /**
     * Apply the discount to all merchandise.
     */
    type: CreateCouponBatchShopifyAllTarget.TypeEnum;
}
export namespace CreateCouponBatchShopifyAllTarget {
    export const TypeEnum = {
        All: 'all'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


